import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Slide } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ProductComponent from './ProductComponent';

export const ProductList = ({
  onSelect,
  products,
  selectingProductId,
  computingSimulations,
  areGraceRatesVisible,
  areGuaranteeRatesVisible,
  productsViewMode,
  processing,
  setFavoriteProduct,
  setDeleteProduct,
  exportSimulationButtonVisible
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const select = product => () => {
    onSelect(product);
  };

  const sortProducts = products => {
    if (!(products && products.length)) return [];
    const sortedProducts = products.sort((product, nextProduct) => {
      return nextProduct.isActive - product.isActive || nextProduct.isSpecialAction - product.isSpecialAction;
    });

    return sortedProducts;
  };

  const errorMessageExists = messages => {
    return messages?.some(x => x.messageType === 2);
  };
  const renderProduct = (p, i) => {
    return (
      <Slide key={`${p.productId} - ${i}`} direction='up' in={true} timeout={computingSimulations ? 2000 * i : 0}>
        {productsViewMode === 0 || productsViewMode === 1 ? (
          <Grid
            item
            key={`${p.productId} - ${i}`}
            xs={12}
            sm={productsViewMode === 0 ? 6 : 12}
            md={productsViewMode === 0 ? 6 : 12}
            lg={productsViewMode === 0 ? 4 : 12}
          >
            <ProductComponent
              key={`${p.productId} - ${i}`}
              productsViewMode={productsViewMode}
              idx={i}
              product={p}
              onSelect={select(p)}
              isSelected={
                selectingProductId === p.productId || (p.selected && (selectingProductId === null || selectingProductId === undefined))
              }
              isSelecting={selectingProductId === p.productId}
              isSelectable={selectingProductId === null || selectingProductId === undefined}
              computingSimulations={computingSimulations}
              areGraceRatesVisible={areGraceRatesVisible}
              areGuaranteeRatesVisible={areGuaranteeRatesVisible}
              processing={processing}
              setFavoriteProduct={setFavoriteProduct}
              setDeleteProduct={setDeleteProduct}
              errorMessageExists={errorMessageExists}
              exportSimulationButtonVisible={exportSimulationButtonVisible}
            />
          </Grid>
        ) : (
          <div></div>
        )}
      </Slide>
    );
  };

  return (
    <Grid container spacing={productsViewMode === 1 ? 0 : 4} alignItems='stretch'>
      {!matches
        ? sortProducts(products).map(renderProduct)
        : Object.assign([], products)
            .sort((x, y) => (x.isActive === y.isActive ? 0 : x.isActive ? -1 : 1))
            .map(renderProduct)}
    </Grid>
  );
};

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectingProductId: PropTypes.number,
  computingSimulations: PropTypes.bool.isRequired,
  areGraceRatesVisible: PropTypes.bool.isRequired,
  areGuaranteeRatesVisible: PropTypes.bool.isRequired,
  productsViewMode: PropTypes.number.isRequired,
  processing: PropTypes.bool,
  setFavoriteProduct: PropTypes.func.isRequired,
  setDeleteProduct: PropTypes.func.isRequired,
  exportSimulationButtonVisible: PropTypes.bool
};

export default withTranslation()(ProductList);
